document.addEventListener('click', function (e) {
  if (e.target.matches('.sub-product-add-to-cart-btn')) {
    const variantId = e.target.getAttribute('data-variant-id');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1
          }
        ]
      })
    })
    .then(response => response.json())
    .then(cart => {
      console.log('Added to cart:', cart);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
    });
  }
});
